export const getAuth = (state) => state.auth
export const getOrgs = (state) => state.org
export const getTeams = (state) => state.team
export const getSchedules = (state) => state.schedule
export const getUsers = (state) => state.users
export const getGames = (state) => state.game
export const getFavs = (state) => state.fav
export const getFeed = (state) => state.feed
